<template>
    <div class="shopMob padding-20 bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="店铺装修" name="decorateTheShop">
                <homePage></homePage>
            </el-tab-pane>
            <el-tab-pane label="微页面" name="microPage">
                <micro-page></micro-page>
            </el-tab-pane>
        </el-tabs>
        <div class="right_help_box bgc padding-20" :class="showHelp ? 'show_helps_box' : 'hide_icon_box'" ref="helps">
            <div class="show_helps" :class="showHelp ? 'show_icon' : 'hide_icon'" @click="isShow()"></div>
            <div class="title_box">
                <span>基本信息</span>
                <span>进入></span>
            </div>
            <p>内容管理可添加哪些商品？</p>
            <p>可以添加图文、音频、视频、直播、专栏、大专栏、会员、分销商品。</p>
            <div class="issue_box">
                <ul>
                    <li><a href="#">商品分组使用教程</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">能否批量添加商品？</a></li>
                    <li><a href="#">添加完商品是否能自定义排序？</a></li>
                </ul>
            </div>
        </div>

    </div>
</template>
<script>
import HomePage from 'views/shopMgt/mob/page/homePage.vue'
import MicroPage from 'views/shopMgt/mob/page/microPage.vue'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'shopMob',
    data() {
        // const SortableItem = {
        //     template: `<${wHeader} class ="list-item"></${wHeader}>`,
        // };
        return {
            activeName: 'decorateTheShop',
            showHelp: false
        }
    },
    mounted() {
        if (this.params.shopMob && this.params.shopMob.activeName) {
            this.activeName = this.params.shopMob.activeName
        } else {
            this.setParams({shopMob: {activeName: this.activeName}})
        }
    },
    methods: {
        handleClick(tab, event) {
            this.setParams({shopMob: {activeName: tab.name}})
        },
        isShow() {
            this.showHelp = !this.showHelp
        },
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'params'
        ])
    },
    components: {
        HomePage, MicroPage
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
.shopMob {
    padding-top: 0;
    .right_help_box{
        position: fixed;
        top: 70px;
        right: -225px;
        height: 91vh;
        width: 225px;
        z-index: 10;
        box-sizing: border-box;
        border-top: 2px solid #409EFF;
        box-shadow: 2px 0px 6px 0px rgba(0,21,41,0.14);
        .show_helps{
            width: 12px;
            height: 50px;
            background-size:12px 50px !important;
            position: absolute;
            top: 30%;
            left: -12px;
            cursor: pointer;
            border-radius: 6px 0 0 6px;
        }
        .show_helps:hover{
            background-color: #ccc;
        }
        .show_icon{
            background-image: url('../../../common/images/other/show.png');
        }
        .hide_icon{
            background-image: url('../../../common/images/other/hide.png');
        }
        .title_box{
            display: flex;
            justify-content: space-between;
            border-left: 2px solid #409EFF;
            padding-left: 8px;
            span{
                line-height: 16px;
                font-weight: bold;
            }
            span:nth-of-type(2){
                color: #409EFF;
                font-size: 12px;
                font-weight: normal;
                cursor: pointer;
            }
            span:nth-of-type(2):hover{
                color: rgb(29, 134, 238);
            }
        }
        &>p:nth-of-type(1){
            color:rgba(48,49,51,1);
            margin: 20px 0;
            font-weight: bold;
            // font-size: 15px;
            line-height:20px;
            font-family:PingFangSC-Regular;
        }
        &>p:nth-of-type(2){
            color:rgba(144,147,153,1);
            font-family:PingFangSC-Regular;
            line-height:18px;
            font-size: 12px;
            margin-bottom: 20px;
        }
        .issue_box{
            background-color: #F5F7FA;
            padding: 15px 12px;
            ul{
                padding-left: 10px;
                li{
                    list-style: disc;
                    margin-bottom: 15px;
                    a{
                        font-size:13px;
                        height:18px;
                        color:rgba(64,158,255,1);
                        font-family:PingFangSC-Regular;
                        line-height:18px;
                    }
                }
                li:nth-last-of-type(1){
                    margin-bottom: 0;
                }
            }
        }
    }
    .show_helps_box{
        right: 0;
        transition: 1s all;
    }
    .hide_icon_box{
        right: -225px;
        transition: 1s all;
    }
    .decorateTheShop .is-active{
        background: transparent !important;
    }
}
</style>
